<script>
import {useStore} from "vuex";
import {ref} from "vue";
import Swals from "@/assets/js/Swals";
import FreeWorld from "@/assets/js/FreeWorld";
import $ from "jquery";
import DatePicker from 'vue3-persian-datetime-picker'
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import axios from "axios";
import LoadingPic from "@/components/assetComponents/LoadingPic.vue";
import persianDate from 'persian-date';

export default {
  name: "ProfileEdit",
  components: {LoadingPic, LoadingPage , DatePicker},
  setup() {

    let store = useStore()
    let states = ref([])
    let cities = ref([])
    let guilds = ref([])
    let loading = ref(false)

    let data = ref(store.state.Profile)

    let pics = ref({
      profile:{
        loading:false,
        url:data.value.profile_pic,
      },
      header:{
        loading:false,
        url:data.value.header_pic,
      }
    })

    let cheque = ref()
    data.value.cheque !== 0 ? cheque.value = true : cheque.value = false

    setTimeout(()=>{
      let div = document.getElementById('cheque')
      let icon = $("#icon")
      if (cheque.value){
        div.style.height = '15.5rem'
        icon.removeClass('min_rotate_icon').addClass('rotate_icon')
      }else {
        div.style.height = '4.5rem'
        icon.removeClass('rotate_icon').addClass('min_rotate_icon')
      }
    },100)

    function get_guilds() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'guilds'}, 'info').then((res) => {

        guilds.value = res.data
        get_country()

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_guilds, true)
      })
    }
    get_guilds()

    function get_country() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'cities'}, 'info').then((res) => {

        loading.value = false
        states.value = res.data
        change_state()

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_country, true)
      })
    }


    // watch(()=>cheque.value , ()=>{
    //
    //   console.log('sss')
    //   let div = document.getElementById('cheque')
    //   let icon = $("#icon")
    //
    //   if (cheque.value){
    //     div.style.height = '12rem'
    //     icon.removeClass('min_rotate_icon').addClass('rotate_icon')
    //     data.value.cheque = 1
    //   }else {
    //     div.style.height = '50px'
    //     icon.removeClass('rotate_icon').addClass('min_rotate_icon')
    //     data.value.cheque = 0
    //   }
    //
    // })


    function change_state() {

      states.value.forEach((item)=>{
        if (item.id == data.value.prov_id){
          cities.value = item.city
        }
      })

    }

    function upload_profile(e) {

      const file = e.target.files[0];
      if (file != undefined) {

        pics.value.profile.loading = true

        axios.post(localStorage.getItem('DOM') + "upload", {
              file: file,
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }).then((res)=>{

          pics.value.profile.loading = false
          if (res.data.status === 'ok') {
            pics.value.profile.url = URL.createObjectURL(file);
            data.value.profile_pic = res.data.name
          }else {
            Swals.Fault('لطفا از فرمت عکس مورد نظر اطمینان حاصل فرمایید!')
          }

        }).catch((res) => {
          pics.value.profile.loading = false
          Swals.Catch(res , ()=>{upload_profile(e)})
        })
      }


    }

    function upload_header(e) {

      const file = e.target.files[0];
      if (file != undefined) {

        pics.value.header.loading = true

        axios.post(localStorage.getItem('DOM') + "upload", {
              file: file,
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }).then((res)=>{

          pics.value.header.loading = false
          if (res.data.status === 'ok') {
            pics.value.header.url = URL.createObjectURL(file);
            data.value.header_pic = res.data.name
          }else {
            Swals.Fault('لطفا از فرمت عکس مورد نظر اطمینان حاصل فرمایید!')
          }

        }).catch((res) => {
          pics.value.header.loading = false
          Swals.Catch(res , ()=>{upload_profile(e)})
        })
      }


    }

    function register() {

      if (data.value.type === 'real' && data.value.name.trim().length === 0) {Swals.Warning('لطفا نام و نام خانوادگی خود را وارد کنید!'); return false}
      if (data.value.type === 'real' && data.value.codeid.trim().length === 0) {Swals.Warning('لطفا کد ملی خود را وارد کنید!'); return false}
      if (data.value.type === 'real' && data.value.address.trim().length === 0) {Swals.Warning('لطفا آدرس فروشگاه خود را وارد کنید!'); return false}
      if (data.value.type === 'real' && data.value.codepost.trim().length === 0) {Swals.Warning('لطفا کد پستی خود را وارد کنید!'); return false}
      if (data.value.type === 'real' && data.value.shopname.trim().length === 0) {Swals.Warning('لطفا نام فروشگاه خود را وارد کنید!'); return false}

      if (data.value.type === 'legal' && data.value.shopname.trim().length === 0) {Swals.Warning('لطفا نام فروشگاه خود را وارد کنید!'); return false}
      if (data.value.type === 'legal' && data.value.company_enum.trim().length === 0) {Swals.Warning('لطفا شماره اقتصادی شرکت را وارد کنید!'); return false}
      if (data.value.type === 'legal' && data.value.codeid.trim().length === 0) {Swals.Warning('لطفا شماره ملی شرکت را وارد کنید!'); return false}
      if (data.value.type === 'legal' && data.value.codepost.trim().length === 0) {Swals.Warning('لطفا کدپستی شرکت را وارد کنید!'); return false}
      if (data.value.type === 'legal' && data.value.address.trim().length === 0) {Swals.Warning('لطفا آدرس شرکت را وارد کنید!'); return false}
      if (data.value.type === 'legal' && data.value.birthday === null) {Swals.Warning('لطفا تاریخ تاسیس شرکت را وارد کنید!'); return false}
      if (data.value.type === 'legal' && data.value.company_ref_name.trim().length === 0) {Swals.Warning('لطفا نام معرف خود را وارد کنید!'); return false}
      if (data.value.type === 'legal' && data.value.company_ref_phone.length !== 11) {Swals.Warning('لطفا شماره معرف خود را وارد کنید!'); return false}

      if (data.value.profile_pic === null) {Swals.Warning('لطفا یک تصویر پروفایل برای خود انتخاب کنید!'); return false}
      if (data.value.header_pic === null) {Swals.Warning('لطفا یک تصویر پروفایل برای خود انتخاب کنید!'); return false}

      let now = new Date();
      let persianNow = new persianDate(now);
      persianNow.formatPersian = false; // تنظیم کردن فرمت اعداد به انگلیسی
      let x = persianNow.format('YYYY/MM/DD');

      if (data.value.type === 'legal' && data.value.birthday > x){
        Swals.Warning('لطفا تاریخ تاسیس شرکت را به صورت صحیح انتخاب کنید! ')
        return false
      }
      if (data.value.type === 'real' && data.value.birthday === x || data.value.birthday > x){
        Swals.Warning('لطفا تاریخ تولد خود را یه صورت صحیح انتخاب کنید! ')
        return false
      }

      loading.value = true
      FreeWorld.Heisenberg(data.value , 'shop/register').then((res)=>{

        loading.value = false
        if (res.data.status == 'ok'){

          Swals.Done('پروفایل شما با موفقیت ویرایش شد','HomaPage')

        }else if(res.data.event == 'duplicate phone'){
          Swals.Fault('پروفایل شما قبلا ثبت شده است' , 'LoginPage')
        } else{
          Swals.Fault('متاسفانه ثبت نام شما انجام نشد')
        }

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , register)
      })

    }


    return {

      data,
      states,
      cities,
      guilds,
      change_state,
      register,
      loading,
      cheque,
      upload_profile,
      upload_header,
      pics,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass' : '' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">مدیریت اطلاعات</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div class="w-100 p-body mt-3 ">

      <div class="shadow-custom rounded-4 overflow-hidden bg-white">

        <div v-if="data.type === 'real'" class="p-body mt-5">

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام و نام خانوادگی مالک فروشگاه*</p>
            <input v-model="data.name" disabled class="shadow-custom bg-white text-center font-4 rounded-4 w-100 p-3" type="text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">کد ملی*</p>
            <input v-model="data.codeid" disabled class="shadow-custom bg-white font-4 text-center rounded-4 w-100 p-3" type="tel" onkeydown="return event.key !== ' '">
          </div>

          <div class="my-4 d-flex justify-content-center align-items-center">
            <div class="w-50">
              <p class="m-0 me-2 mb-2 font-4 font-bold font-color">استان*</p>
              <select v-model="data.prov_id" @change="change_state" disabled class="text-center w-100 shadow-custom  bg-white p-3 rounded-4">
                <option v-for="item in states" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </div>
            <div class="w-50 me-2">
              <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شهر*</p>
              <select v-model="data.city_id" disabled class="text-center w-100 shadow-custom bg-white p-3 rounded-4">
                <option v-for="item in cities" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </div>
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">آدرس فروشگاه*</p>
            <textarea style="min-height: 100px;resize: none" disabled v-model="data.address" class="shadow-custom bg-white font-4 rounded-4 w-100 p-3"></textarea>
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">کد پستی*</p>
            <input v-model="data.codepost" disabled class="shadow-custom bg-white text-center font-4 rounded-4 w-100 p-3" type="tel">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">ایمیل</p>
            <input v-model="data.email" disabled class="shadow-custom bg-white font-4 text-center rounded-4 w-100 p-3" type="text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">تلفن ثابت</p>
            <input v-model="data.telephone" disabled class="shadow-custom bg-white text-center text-center font-4 rounded-4 w-100 p-3" type="tel" onkeydown="return event.key !== ' '">
          </div>

          <div class="mt-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">تاریخ تولد</p>
            <div class="shadow-custom bg-white font-4 rounded-4 w-100 py-3 px-2 text-center">
              <date-picker class="text-center border-0" disabled v-model="data.birthday"></date-picker>
            </div>
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام فروشگاه*</p>
            <input v-model="data.shopname" disabled class="shadow-custom bg-white text-center font-4 rounded-4 w-100 p-3" type="text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">صنف فعالیت*</p>
            <select v-model="data.category_id" disabled class="text-center bg-white w-100 shadow-custom p-3 rounded-4">
              <option v-for="item in guilds" :key="item.id" :value="item.id">{{ item.name }}</option>
            </select>
          </div>

          <div style="transition: .5s;height: 4.5rem" id="cheque" class="p-body overflow-hidden py-3 rounded-3 shadow-custom bg-white w-100 ">

            <div class="d-flex align-items-center">
              <input v-model="cheque" disabled id="cheque_input" type="checkbox">
              <label for="cheque_input" class="d-flex w-100 justify-content-between align-items-center">
                <div class="d-flex justify-content-center align-items-center">
                  <p class="me-2 font-color font-4 font-bold">امکان پرداخت چکی</p>
                </div>
                <img id="icon" src="../assets/img/arrow.png" style="width: 10px;height: 5px">
              </label>
            </div>

            <p class="font-5 text-dark mt-4">درصورت تایید پرداخت با چک، امکان خرید
              چکی برای کاربر فعال میگردد</p>

            <div class="d-flex justify-content-start align-items-start w-100 mt-3 ">
              <div class="d-flex justify-content-start align-items-center w-50">
                <input disabled v-model="data.cheque" :value="1" type="radio" name="cheque">
                <p class="m-0 me-2 font-4">یک ماه</p>
              </div>
              <div class="d-flex justify-content-start align-items-center w-50">
                <input disabled v-model="data.cheque" :value="3" type="radio" name="cheque">
                <p class="m-0 me-2 font-4">حداکثر سه ماه</p>
              </div>
            </div>
            <div class="d-flex justify-content-start align-items-start w-100 mt-3 ">
              <div class="d-flex justify-content-start align-items-center w-50">
                <input disabled v-model="data.cheque" :value="2" type="radio" name="cheque">
                <p class="m-0 me-2 font-4">حداکثر دو ماه</p>
              </div>
              <div class="d-flex justify-content-start align-items-center w-50">
                <input disabled v-model="data.cheque" :value="4" type="radio" name="cheque">
                <p class="m-0 me-2 font-4">حداکثر چهار ماه</p>
              </div>
            </div>
          </div>

          <div class="my-4">
            <p class="me-2 mb-2 font-4 font-bold font-color">تصویر پروفایل*</p>
            <div class="">
              <input @change="upload_profile" disabled id="profile" style="display: none" type="file">

              <label class="shadow-custom rounded-4 position-relative" style="height: 10rem;width: 10rem" for="profile">
                <img v-if="pics.profile.url !== null" class="w-100 h-100 rounded-4" :src="pics.profile.url">
                <img v-else class="w-100 h-100 rounded-4" src="../assets/img/add_profile.svg">
                <LoadingPic v-if="pics.profile.loading"></LoadingPic>
              </label>
            </div>
          </div>

          <div class="my-4">
            <p class="me-2 mb-2 font-4 font-bold font-color">تصویر سر صفحه*</p>
            <div class="">
              <input @change="upload_header" disabled id="header" style="display: none" type="file">

              <label class="shadow-custom rounded-4 w-100 position-relative" style="height: 12rem" for="header">
                <img v-if="pics.header.url !== null" class="w-100 h-100 rounded-4" :src="pics.header.url">
                <img v-else class="w-100 h-100 rounded-4" src="../assets/img/add_photo.svg">
                <LoadingPic v-if="pics.header.loading"></LoadingPic>
              </label>
            </div>
          </div>

<!--          <v-btn @click="register" class="py-3 h-100 mb-4 w-100 border-0 rounded-3 bg-color text-white">ثبت نهایی</v-btn>-->

        </div>

        <div v-if="data.type === 'legal'" class="p-body mt-5">

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام شرکت*</p>
            <input disabled v-model="data.shopname" class="shadow-custom bg-white font-4 text-center rounded-4 w-100 p-3 text-center" type="text" placeholder="فروشگاه شما در اپلیکیشن با این نام نمایش داده میشود">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شماره اقتصادی شرکت*</p>
            <input disabled v-model="data.company_enum" class="shadow-custom bg-white text-center font-4 rounded-4 w-100 p-3 text-center" type="text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شناسه ملی شرکت*</p>
            <input disabled v-model="data.codeid" class="shadow-custom bg-white font-4 text-center rounded-4 w-100 p-3 text-center" type="text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">کد پستی شرکت*</p>
            <input disabled v-model="data.codepost" class="shadow-custom bg-white font-4 text-center rounded-4 w-100 p-3" type="text">
          </div>

          <div class="my-4 d-flex justify-content-center align-items-center">
            <div class="w-50">
              <p class="m-0 me-2 mb-2 font-4 font-bold font-color">استان*</p>
              <select disabled v-model="data.prov_id" class="text-center w-100 shadow-custom bg-white p-3 rounded-4">
                <option v-for="item in states" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </div>
            <div class="w-50 me-2">
              <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شهر*</p>
              <select disabled v-model="data.city_id" class="text-center w-100 shadow-custom bg-white p-3 rounded-4">
                <option v-for="item in cities" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </div>
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">آدرس شرکت / فروشگاه*</p>
            <textarea disabled style="min-height: 100px;resize: none" v-model="data.address" class="shadow-custom bg-white font-4 rounded-4 w-100 p-3"></textarea>
          </div>


          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">تلفن ثابت</p>
            <input disabled v-model="data.telephone" class="shadow-custom bg-white font-4 text-center rounded-4 w-100 p-3" type="tel" onkeydown="return event.key !== ' '">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">ایمیل</p>
            <input disabled v-model="data.email" class="shadow-custom bg-white font-4 text-center rounded-4 w-100 p-3" type="text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">وب سایت</p>
            <input disabled v-model="data.website" class="shadow-custom bg-white font-4 text-center rounded-4 w-100 p-3" type="text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام نمایشگاه شرکت</p>
            <input disabled v-model="data.company_ename" class="shadow-custom bg-white text-center font-4 rounded-4 w-100 p-3" type="Text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">دسته بندی فعالیت*</p>
            <select disabled v-model="data.category_id" class="text-center bg-white w-100 shadow-custom p-3 rounded-4">
              <option v-for="item in guilds" :key="item.id" :value="item.id">{{ item.name }}</option>
            </select>
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شماره روزنامه رسمی</p>
            <input disabled v-model="data.company_number" class="shadow-custom bg-white text-center font-4 rounded-4 w-100 p-3" type="text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">تاریخ روزنامه رسمی</p>
            <input disabled v-model="data.company_date" class="shadow-custom bg-white text-center font-4 rounded-4 w-100 p-3" type="text">
          </div>

          <div class="mt-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">تاریخ تاسیس *</p>
            <div class="shadow-custom bg-white font-4 rounded-4 w-100 py-3 px-2 text-center">
              <date-picker disabled class="text-center border-0" v-model="data.birthday"></date-picker>
            </div>
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام مدیر عامل</p>
            <input disabled v-model="data.name" class="shadow-custom text-center bg-white font-4 rounded-4 w-100 p-3" type="text">
          </div>

          <p class="m-0 me-2 mb-2 font-3 font-bold font-color">نماینده معرفی شده</p>
          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">نام و نام خانوادگی*</p>
            <input disabled v-model="data.company_ref_name" class="shadow-custom text-center bg-white font-4 rounded-4 w-100 p-3" type="text">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">شماره موبایل*</p>
            <input disabled v-model="data.company_ref_phone" class="shadow-custom text-center bg-white font-4 rounded-4 w-100 p-3" maxlength="11" type="tel" onkeydown="return event.key !== ' '">
          </div>

          <div class="my-4">
            <p class="m-0 me-2 mb-2 font-4 font-bold font-color">ایمیل</p>
            <input disabled v-model="data.company_ref_email" class="shadow-custom text-center bg-white font-4 rounded-4 w-100 p-3" type="text">
          </div>

          <div class="my-4">
            <p class="me-2 mb-2 font-4 font-bold font-color">تصویر پروفایل*</p>
            <div class="">
              <input disabled @change="upload_profile" id="profile" style="display: none" type="file">

              <label class="shadow-custom rounded-4 position-relative" style="height: 10rem;width: 10rem" for="profile">
                <img v-if="pics.profile.url !== null" class="w-100 h-100 rounded-4" :src="pics.profile.url">
                <img v-else class="w-100 h-100 rounded-4" src="../assets/img/add_profile.svg">
                <LoadingPic v-if="pics.profile.loading"></LoadingPic>
              </label>
            </div>
          </div>

          <div class="my-4">
            <p class="me-2 mb-2 font-4 font-bold font-color">تصویر سر صفحه*</p>
            <div class="">
              <input disabled @change="upload_header" id="header" style="display: none" type="file">

              <label class="shadow-custom rounded-4 w-100 position-relative" style="height: 15rem" for="header">
                <img v-if="pics.header.url !== null" class="w-100 h-100 rounded-4" :src="pics.header.url">
                <img v-else class="w-100 h-100 rounded-4" src="../assets/img/add_photo.svg">
                <LoadingPic v-if="pics.header.loading"></LoadingPic>
              </label>
            </div>
          </div>

<!--          <v-btn @click="register" class="py-3 h-100 mb-4 w-100 border-0 rounded-3 bg-color text-white">ثبت نهایی</v-btn>-->

        </div>

      </div>
    </div>
    <br>
    <br>

  </div>

</template>

<style scoped>

.rotate_icon {
  transform: rotate(180deg);
  transition: .5s;
}

.min_rotate_icon {
  transform: rotate(0deg);
  transition: .5s;
}

.shadow_select {
  box-shadow: 0 -10px 10px -2px #707070;
}

</style>